// extracted by mini-css-extract-plugin
module.exports = {"section":"Settings_section__3dB5v","versionsContainer":"Settings_versionsContainer__9cx0L","chip":"Settings_chip__6itqu","inputWrapper":"Settings_inputWrapper__Irq0X"};